module.exports = __webpack_public_path__ + "img/icon-commission-cashback.90dc40b6.svg";